import { render, staticRenderFns } from "./Accident.vue?vue&type=template&id=aba1141c&scoped=true&"
import script from "./Accident.vue?vue&type=script&lang=js&"
export * from "./Accident.vue?vue&type=script&lang=js&"
import style0 from "./Accident.vue?vue&type=style&index=0&id=aba1141c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba1141c",
  null
  
)

export default component.exports